import { render, staticRenderFns } from "./GdprDetail.vue?vue&type=template&id=1a761cbc&scoped=true"
import script from "./GdprDetail.vue?vue&type=script&lang=js"
export * from "./GdprDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a761cbc",
  null
  
)

export default component.exports